import { Observable } from 'rxjs';

export class InitMessage {
    public constructor(
        public key: INIT_MESSAGE_KEY,
        public state: INIT_MESSAGE_STATE,
        public description: Observable<string>,
        public duration: Observable<string>,
    ) {}
}

// TODO: i18n. Provide i18n key instead of literal translation; have component translate it
export enum INIT_MESSAGE_STATE {
    PENDING = 'Pending',
    SUCCESS = 'Success',
    WARNING = 'Warning',
    ERROR = 'Error',
    ADDED = 'Added',
}

// TODO: i18n. Provide i18n key instead of literal translation; have component translate it
export enum INIT_MESSAGE_KEY {
    DATE_TIME_CHECK = 'Check date and time',
    CLEAR_MESSAGES = 'Clear messages',
    APP_START = 'App start',
    CESWRAPPER = 'CesWrapper',
    APP_VERSION = 'App version',
    SYNC_APP_VERSION = 'Sync app version',
    INTERNET_CONNECTION = 'Internet connection',
    AUTHENTICATION = 'Authentication',
    PUSH_NOTIFICATIONS = 'Push notifications',
    USER_MASTER_DATA = 'User master data',
    CONFIG_INTERFACE = 'Config interface',
    RESUME_EVENT_HANDLING = 'Resume event handling',
    SERVICE_INIT = 'Service init',
    ENCRYPTION_KEY = 'App data encryption',
    SIDE_MENU = 'Side menu setup',
    DATE_MANIPULATION_SERVICE = 'Secure date manipulation',
    PWA_SERVICE_WORKER_REGISTRATION = 'PWA Service Worker registration',
    PWA_APP_UPDATE = 'PWA app update',
    PWA_PUSH_NOTIFICATIONS = 'PWA Push Notifications',
    LEGACY_ENCRYPTION = 'Legacy data encryption',
    DEVICE_LOCK_CHECK = 'Device locking',
    CONCURRENT_DATA = 'Concurrent data sync',
    APP_CONFIG = 'App config',
}
